// @flow
import * as React from 'react';
import { getTimeUntilDate } from '../../utils/date';

import type { Timer } from '../../utils/date';

type RequiredProps = {| endTime: string |};
type InjectedProps = {| timer: Timer |};

function withTimer<OwnProps>(
  Component: React.AbstractComponent<{|
    ...OwnProps,
    ...InjectedProps,
  |}>,
  intervalMs: number = 1000
): React.AbstractComponent<{| ...OwnProps, ...RequiredProps |}> {
  type Props = {|
    ...OwnProps,
    ...RequiredProps,
  |};

  type State = {
    timer: Timer,
    timerIntervalId: IntervalID | null,
  };

  return class WithTimer extends React.Component<Props, State> {
    state = {
      timer: { days: '0', hours: '0', minutes: '0', seconds: '0' },
      timerIntervalId: null,
    };

    componentDidMount = () => {
      const interval = setInterval(this.setTimer, intervalMs);
      this.setState({ timerIntervalId: interval });
    };

    componentWillUnmount = () => {
      clearInterval(this.state.timerIntervalId);
    };

    setTimer = () =>
      this.setState({
        timer: getTimeUntilDate(this.props.endTime),
      });

    render() {
      const { endTime, ...rest } = this.props;
      return <Component {...rest} timer={this.state.timer} />;
    }
  };
}

export default withTimer;
